import { render, staticRenderFns } from "./BlockEditorHeading4.vue?vue&type=template&id=cdd6851a&"
import script from "./BlockEditorHeading4.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorHeading4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports